/**
 * plugins/i18n.js
 *
 * Framework documentation: https://vue-i18n.intlify.dev/
 */

import { createI18n } from 'vue-i18n';
import nl from '@/locales/nl.json';
import en from '@/locales/en.json';
import de from '@/locales/de.json';
import es from '@/locales/es.json';

const i18n = createI18n({
  legacy: false,
  messages: { nl, en, de, es },
  globalInjection: true,
});

export default i18n;

